import { ReactNode } from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import PageWrapper from "components/PageWrapper";
import { getDocsUrl } from "utils/getDocsUrl";
import PageInfoHeader from "ds/components/PageInfoHeader";

import styles from "./styles.module.css";

type LimitsPageLayoutProps = {
  children: ReactNode;
};

const LimitsPageLayout = ({ children }: LimitsPageLayoutProps) => {
  return (
    <>
      <PageInfoHeader title="Limits">
        <DocumentationIconButton
          href={getDocsUrl("/concepts/run#limit-runs")}
          tooltipText="Go to limit runs documentation"
        />
      </PageInfoHeader>
      <PageWrapper className={styles.container}>{children}</PageWrapper>
    </>
  );
};

export default LimitsPageLayout;
